"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithCSSTransition = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const react_transition_group_1 = require("react-transition-group");
const WithCSSTransition = (props) => {
    const { in: visible, dimension = 'height', children, ...rest } = props;
    const expandedSize = React.useRef(0);
    const dimensionCamelCase = dimension === 'height' ? 'Height' : 'Width';
    return (React.createElement(react_transition_group_1.CSSTransition, { in: visible, timeout: 200, unmountOnExit: true, onEnter: (node) => {
            node.style[`min${dimensionCamelCase}`] = 'initial';
            node.style[dimension] = '0px';
        }, onEntering: (node) => {
            node.style[dimension] = `${expandedSize.current}px`;
        }, onEntered: (node) => {
            node.style[`min${dimensionCamelCase}`] = '';
            node.style[dimension] = '';
        }, onExit: (node) => {
            node.style[dimension] = `${expandedSize.current}px`;
        }, onExiting: (node) => {
            node.style[`min${dimensionCamelCase}`] = 'initial';
            node.style[dimension] = '0px';
        }, classNames: 'iui', ...rest }, React.cloneElement(children, {
        ref: (el) => {
            if (el) {
                expandedSize.current = el.getBoundingClientRect()[dimension];
            }
        },
    })));
};
exports.WithCSSTransition = WithCSSTransition;
exports.default = exports.WithCSSTransition;
